/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardDto } from '../../models/dashboard-dto';
import { UpdateDashboardRequest } from '../../models/update-dashboard-request';

export interface DashboardsDashboardIdPut$Plain$Params {
  dashboardId: string;
      body?: UpdateDashboardRequest
}

export function dashboardsDashboardIdPut$Plain(http: HttpClient, rootUrl: string, params: DashboardsDashboardIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardsDashboardIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardDto>;
    })
  );
}

dashboardsDashboardIdPut$Plain.PATH = '/dashboards/{dashboardId}';
